var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", [
    _c("ul", { staticClass: "nav nav-tabs mb-3", attrs: { role: "tablist" } }, [
      _c("li", { staticClass: "nav-item", attrs: { role: "presentation" } }, [
        _c(
          "a",
          {
            staticClass: "nav-link",
            class: { active: _vm.activeTab === _vm.AvailableTabs.Login },
            attrs: { href: `#${_vm.AvailableTabs.Login}`, role: "tab" },
            on: {
              click: function ($event) {
                $event.preventDefault()
                return _vm.setActiveTab(_vm.AvailableTabs.Login)
              },
            },
          },
          [_vm._v(" " + _vm._s(_vm.T.omegaupTitleLogin) + " ")]
        ),
      ]),
      _c("li", { staticClass: "nav-item", attrs: { role: "presentation" } }, [
        _c(
          "a",
          {
            staticClass: "nav-link",
            class: { active: _vm.activeTab === _vm.AvailableTabs.Signup },
            attrs: { href: `#${_vm.AvailableTabs.Signup}`, role: "tab" },
            on: {
              click: function ($event) {
                $event.preventDefault()
                return _vm.setActiveTab(_vm.AvailableTabs.Signup)
              },
            },
          },
          [_vm._v(" " + _vm._s(_vm.T.loginSignUp) + " ")]
        ),
      ]),
    ]),
    _c("div", { staticClass: "tab-content" }, [
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.activeTab === _vm.AvailableTabs.Login,
              expression: "activeTab === AvailableTabs.Login",
            },
          ],
          staticClass: "tab-pane",
          class: { active: _vm.activeTab === _vm.AvailableTabs.Login },
          attrs: { role: "tabpanel" },
        },
        [
          _c("omegaup-login", {
            attrs: {
              "active-tab": _vm.activeTab,
              "facebook-url": _vm.facebookUrl,
              "github-client-id": _vm.githubClientId,
              "github-state": _vm.githubState,
              "google-client-id": _vm.googleClientId,
            },
            on: {
              login: (username, password) =>
                _vm.$emit("login", username, password),
            },
          }),
        ],
        1
      ),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.activeTab === _vm.AvailableTabs.Signup,
              expression: "activeTab === AvailableTabs.Signup",
            },
          ],
          staticClass: "tab-pane",
          class: { active: _vm.activeTab === _vm.AvailableTabs.Signup },
          attrs: { role: "tabpanel" },
        },
        [
          _c("omegaup-signup", {
            attrs: {
              "has-visited-section": _vm.hasVisitedSection,
              "active-tab": _vm.activeTab,
              "validate-recaptcha": _vm.validateRecaptcha,
              "use-signup-form-with-birth-date": _vm.useSignupFormWithBirthDate,
            },
            on: {
              "register-and-login": (request) =>
                _vm.$emit("register-and-login", request),
            },
          }),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }